import { render, staticRenderFns } from "./Concierge.vue?vue&type=template&id=5f53f5df&scoped=true&"
import script from "./Concierge.vue?vue&type=script&lang=js&"
export * from "./Concierge.vue?vue&type=script&lang=js&"
import style0 from "./Concierge.vue?vue&type=style&index=0&id=5f53f5df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f53f5df",
  null
  
)

export default component.exports